import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { EmptyState } from 'components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from "react-router-dom";
import ModuleSet from './ModuleSet';
import EditIcon from '@material-ui/icons/Edit';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));
let mounted = false;

const LessonModules = props => {
  const { className, reload, ...rest } = props;
  const model = useSelector(state => state.models.lesson);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    if (mounted) setOpenEdit(true);
  };

  const handleEditClose = () => {
    if (mounted) setOpenEdit(false);
  };

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, []);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Lesson Modules (DEPRECATED)" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            {model.modules.map((mmodule, index) => (
              <TableRow key={index}>
                <TableCell className={classes.header}>
                  {mmodule.name_en}{mmodule.name_zh ? " " + mmodule.name_zh : ""}
                  <div><Typography variant="caption">{mmodule.code}</Typography></div>
                </TableCell>
                <TableCell align="right">
                  <Button color="primary" component={RouterLink} size="small" to={`/modules/${mmodule.id}/summary`} variant="outlined">
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <EmptyState active={!model.modules.length} message="No modules assigned." />
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <ModuleSet onClose={handleEditClose} reload={reload} open={openEdit} model={model} />
    </Card>
  );
};

LessonModules.propTypes = {
  className: PropTypes.string,
};

export default LessonModules;
